import { AnyAction } from "redux";
import {
  REQUEST_ACTIVATE,
  REQUEST_ACTIVATE_ERROR,
  REQUEST_ACTIVATE_SUCCESS,
} from "redux/actions/pages/activate";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_ACTIVATE:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_ACTIVATE_SUCCESS:
      return {
        ...state,
        data: action.status,
        error: null,
        loading: false,
      };
    case REQUEST_ACTIVATE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
